import React from 'react';
import { Button } from '../../components/ui/Button';
export function IntroSection() {
  return <div className="bg-white py-12 px-4 border-b border-gray-200" data-id="element-1701">
      <div className="max-w-5xl mx-auto text-center space-y-8" data-id="element-1702">
        <h1 className="text-2xl md:text-3xl lg:text-4xl font-bold text-orange leading-tight" data-id="element-1703">
          Peak Machine Sales proudly offers EDM consumables and parts for all
          makes and models including AgieCharmilles, Mitsubishi, Makino, Sodick,
          and more!
        </h1>
        <div data-id="element-1704">
          <Button variant="primary" href="#Request_Quote" size="lg" className="font-bold tracking-wide" data-id="element-1705">
            REQUEST QUOTE
          </Button>
        </div>
      </div>
    </div>;
}